import React from 'react'
import AuctionPrice from '../atoms/AuctionPrice'
import BuyNowPrice from '../atoms/BuyNowPrice'
import View from '../atoms/View'

interface Props {
  highestBet: number
  yourHighestBet: number | null
  tilesView?: boolean
  buyNowPrice: number
}
const Price = ({ highestBet, yourHighestBet, buyNowPrice, tilesView = false }: Props): JSX.Element => {
  return (
    <View>
      {buyNowPrice === 0 ? (
        <AuctionPrice highestBet={highestBet} yourHighestBet={yourHighestBet} tilesView={tilesView} />
      ) : (
        <BuyNowPrice buyNowPrice={buyNowPrice} tilesView={tilesView} />
      )}
    </View>
  )
}

export default Price
